
import React, { useRef, useEffect } from 'react';
import { SearchSection } from './SearchSection';

export const MobileOptimizedSearchSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    // Mark as LCP element for mobile
    if (sectionRef.current && window.innerWidth <= 768) {
      sectionRef.current.setAttribute('data-lcp', 'true');
      sectionRef.current.classList.add('above-fold');
      
      // Preload the search section background
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="1" height="1"><rect width="1" height="1" fill="white"/></svg>';
      document.head.appendChild(link);
    }
  }, []);
  
  return (
    <div 
      ref={sectionRef}
      className="search-section above-fold"
      style={{
        // Reserve space to prevent layout shift
        minHeight: '200px',
        width: '100%'
      }}
    >
      <SearchSection />
    </div>
  );
};
